import { useState, useEffect } from "react";
import { X, Download, Monitor, Smartphone } from "lucide-react";
import SoftTypography from "components/SoftTypography";
import titanLogo from "assets/images/logo.svg";
import "./index.css";

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            setDeferredPrompt(e);
            // Show the install button/popup after a short delay
            setTimeout(() => {
                setIsVisible(true);
            }, 1000);
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

        window.addEventListener("appinstalled", () => {
            // Log install to analytics
            console.log("PWA was installed");
            setIsVisible(false);
            setDeferredPrompt(null);
        });

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);

        // We've used the prompt, and can't use it again, throw it away
        setDeferredPrompt(null);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="install-pwa-overlay">
            <div className="install-pwa-card">
                <button
                    className="install-pwa-close"
                    onClick={() => setIsVisible(false)}
                >
                    <X className="h-4 w-4" />
                </button>

                <div className="install-pwa-content">
                    <div className="install-pwa-logo-container">
                        <img src={titanLogo} alt="Titan LCD" className="install-pwa-logo" />
                        <div className="install-pwa-status-dot"></div>
                    </div>

                    <div className="install-pwa-text">
                        <SoftTypography variant="h6" fontWeight="bold" className="install-pwa-title">
                            Titan LCD App
                        </SoftTypography>
                        <SoftTypography variant="caption" color="text" className="install-pwa-subtitle">
                            Installer l'application pour une meilleure expérience et des notifications en temps réel.
                        </SoftTypography>
                    </div>
                </div>

                <div className="install-pwa-actions">
                    <div className="install-pwa-devices">
                        <Smartphone className="h-3 w-3 opacity-40" />
                        <Monitor className="h-3 w-3 opacity-40" />
                        <span className="text-[10px] font-medium text-zinc-400 ml-1">Compatible</span>
                    </div>

                    <button
                        className="install-pwa-button"
                        onClick={handleInstallClick}
                    >
                        <Download className="h-4 w-4 mr-2" />
                        Installer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InstallPWA;
